import React from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckIcon from '@mui/icons-material/Check';
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";

function ShowUnpublishedShiftsButton(props) {
  if (props.renderAsMenuItem) {
    return (
      <MenuItem
        onClick={() => {
          if (props.monthlyView) return;
          props.setShowUnpublishedShifts((prev) => !prev);
          props.onMenuItemClick?.();
        }}
        disabled={props.monthlyView}
        sx={{ py: 1.25 }}
      >
        <ListItemIcon sx={{ color: props.showUnpublishedShifts ? "#6d28d9" : undefined }}>
          <VisibilityIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            fontSize: 14,
            color: props.showUnpublishedShifts ? "#6d28d9" : undefined,
            fontWeight: props.showUnpublishedShifts ? 600 : 400,
          }}
        >
          Highlight unpublished shifts
        </ListItemText>
        {props.showUnpublishedShifts && (
          <CheckIcon sx={{ color: "#6d28d9", fontSize: 18 }} />
        )}
      </MenuItem>
    );
  }

  return (
    <div>
      <Tooltip title={props.monthlyView ? "Not available in monthly view" : props.showUnpublishedShifts ? "Stop highlighting unpublished shifts" : "Highlight unpublished shifts"}>
        <span>
          <IconButton
            onClick={() => props.setShowUnpublishedShifts(prevState => !prevState)}
            style={{ color: props.showUnpublishedShifts ? "#6d28d9" : undefined }}
            className="group-hover:bg-gray-200 transition"
            disabled={props.monthlyView}
          >
            <VisibilityIcon />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  )
}

export default ShowUnpublishedShiftsButton
